<script>
export default {
  name: 'mixin',
  data() {
    return {
      machineList: [] // 设备列表
    }
  },
  methods: {
    getDevices(pageIndex, pageSize, customerId, deviceTypeCode, deviceStatus, reset) {
      if (reset) {
        this.machineList = []
      }
      const params = {
        pageNo: pageIndex,
        pageSize: pageSize,
        customerId: customerId,
        deviceTypeCode: deviceTypeCode,
        deviceStatus: deviceStatus,
        departmentType: 1 // 写死的数据
      }
      getDeviceList(params).then((res) => {
        if (res.items) {
          this.machineList = this.machineList.concat(res.items)
          this.currentMachine = res.items[0] || {}
          this.deviceTotalCount = res.totalCount
        }
      })
    }
  }
}
</script>
